import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrintComponent = ({ firstName, lastName, appId, email }) => {
  const [loaded, setLoaded] = useState(false);
  const [printed, setPrinted] = useState(false);

  useEffect(() => {
    if (loaded && !printed) {
      // Adding a timeout to ensure the print action happens after the image is fully rendered
      setTimeout(() => {
        window.print();
        setPrinted(true);
      }, 500); // You may adjust this timeout value
    }
  }, [loaded, printed]);
  const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`;

  return (
    <div>
      <div
        style={{
          backgroundColor: '#FFF',
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
        id="printCover"
      />
      <img
        src={image}
        alt={`${firstName} ${lastName}`}
        width="100%"
        height="auto"
        onLoad={() => setLoaded(true)}
      />
      {printed && <Redirect to="/main" />}
    </div>
  );
};

PrintComponent.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  appId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  email: PropTypes.string.isRequired,
};

export default PrintComponent;